import { useClientConfig } from 'src/hooks/useClientConfig';

import './WidgetThumb.sass';

const WidgetThumb = () => {
	const client = useClientConfig();
	const url = client?.thumbnail ? client?.thumbnail + '' : `${window?._env_?.HOST_URL}/vectors/logo-block.svg`;
	return <img className="logo" src={url} alt="logo" />;
};

export default WidgetThumb;
